import {createActions} from 'client/framework';

const supplementActions = createActions(null, [
  'ADD_SUPPLEMENT',
  'FETCH_SUPPLEMENT',
  'QUESTIONSET_SUPPLEMENTS_RECEIVED'
]);

export default supplementActions;
